import { useRedirectUrl } from "@/app/thankyou/hooks/use-redirect-url"
import { Channel } from "@/config/channel"
import { useConfigParams } from "@/hooks/use-config-params"
import { triggerSurveyOnce, TriggerType } from "@/lib/sandsiv/survey-utils"
import { useIpAddressQuery } from "@/services/get-ip-address"
import { usePathname } from "next/navigation"

export function useCloseWithSurveyAction(
  isThankYouPage: boolean,
  triggerSurveyFn: (
    pathname: string,
    channel: Channel,
    type: TriggerType,
    ip: string | null,
  ) => boolean,
) {
  const redirectUrl = useRedirectUrl()
  const pathname = usePathname()
  const { channel, cancelCallbackUrl } = useConfigParams()
  const { data } = useIpAddressQuery()

  return () => {
    if (isThankYouPage) return window.location.assign(redirectUrl)
    if (
      !triggerSurveyOnce(() =>
        triggerSurveyFn(pathname, channel, "cta", data ?? null),
      )
    )
      window.location.assign(cancelCallbackUrl)
  }
}
